import App from 'app/app.js';
import 'app/directive/LtPackageSummaryCtrl.js';

function LtPackageSummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      isScrollable: '=',
      orderLine: '=',
      editIndex: '=',
      isPackage: '=',
      onSave: '&',
      upgradeOptions: '=',
      hasLookValidationError: '=',
      availableEnhancements: '=',
      personalizationIsValid: '=',
      isStandardizedPricingPackage: '=',
      formTouched: '='
    },
    template:
      '<div ng-init="packageSummary.init()"> ' +
      '    <div class="package-summary"> ' +
      '        <div class="row"> ' +
      '            <div class="col-xs-12"> ' +
      '                <h2 class="mara-blue weight-600 summary-title" lt-translate="PACKAGE_DETAIL_PACKAGE_SUMMARY" ng-show="isPackage"></h2> ' +
      '                <h2 class="mara-blue weight-600 summary-title" lt-translate="BUNDLE_DETAIL_PACKAGE_SUMMARY" ng-hide="isPackage"></h2> ' +
      '                <div class="summary-package-title-container"> ' +
      '                        <h2 class="f-misc-25 weight-700"> ' +
      '                           <span ng-bind="orderLine.orderable | ItemDescFilter"></span> ' +
      '                        </h2> ' +
      '                        <h2 class="f-misc-25 weight-700">' +
      '                           <div><span ng-bind="orderLine.orderable.unitPrice | CurrencyLocaleFilter"></span></div>' +
      '                       </h2> ' +
      '                </div> ' +
      '            </div> ' +
      '        </div> ' +
      '        <div class="row" ng-repeat="item in packageSummary.items"> ' +
      '            <div class="col-xs-12"> ' +
      '                <div class="f5 order-line-item" ng-bind="item | ItemDescFilter"></div> ' +
      '            </div> ' +
      '        </div> ' +
      '    </div> ' +
      '    <div class="col-xs-12"> ' +
      '        <div class="add-to-cart-button-container" ng-class="{\'disabled-add-to-cart-button\': ((availableEnhancements.length > 0 && !!upgradeOptions.isValid && !upgradeOptions.isValid(true))  || hasLookValidationError || !personalizationIsValid || packageSummary.hasUncustomizedPersonalizerItems())}">' +
      '            <a class="btn add-to-cart" ng-show="editIndex < 0" ng-click="packageSummary.saveToCart()" data-id="button" data-test-add-to-cart-continue-btn>' +
      '               <span ng-if="isPackage" lt-translate="PACKAGE_DETAIL_ADD_TO_CART_2"></span>' +
      '               <span ng-if="!isPackage" lt-translate="BUNDLE_DETAIL_ADD_TO_CART_2"></span>' +
      '           </a> ' +
      '            <a class="btn add-to-cart" ng-show="editIndex >= 0" ng-click="packageSummary.saveToCart()" data-id="button" data-test-save-btn>' +
      '               <span ng-if="isPackage" lt-translate="PACKAGE_DETAIL_SAVE"></span>' +
      '               <span ng-if="!isPackage" lt-translate="BUNDLE_DETAIL_SAVE"></span>' +
      '           </a> ' +
      '        </div> ' +
      '    </div> ' +
      '    <div class="col-xs-12" ng-hide="(availableEnhancements.length === 0 || (!!upgradeOptions.isValid && upgradeOptions.isValid(true)) || (isStandardizedPricingPackage && personalizationIsValid))"> ' +
      '        <div class="add-to-cart-button-container"> ' +
      '            <p class="text-center f6" lt-translate="SELECT_YOUR_ENHANCEMENT_TEXT"></p> ' +
      '        </div> ' +
      '    </div> ' +
      '    <div class="col-xs-12" ng-hide="((!isStandardizedPricingPackage) || (isStandardizedPricingPackage && personalizationIsValid) || !formTouched)"> ' +
      '        <div class="add-to-cart-button-container"> ' +
      '            <p class="text-left f6 text-alert weight-bold" lt-translate="NOGO_ERROR_MESSAGE" lt-zone="STANDARDIZED_PRICING_PACKAGE_DETAILS"></p> ' +
      '        </div> ' +
      '    </div> ' +
      '</div> ',
    controller: 'LtPackageSummaryCtrl',
    controllerAs: 'packageSummary'
  };
}

App.directive('ltPackageSummary', [LtPackageSummaryDirective]);
